﻿import { Box, Grid, TextField } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUILoadingLinear } from '../../../../atomic/atoms';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { CustomerCommand } from '../../../../services/command';
import TimeHelper from '../../../../utils/time';
import { LAC, lacCls } from './linkedAccountsComponent.classes';

interface IProps {
    datas?: any;
}
export const LinkedAccountsComponent: FC<IProps> = ({ datas }) => {
    const { t } = useTranslation();
    const [customerByIdList, setCustomerByIdList] = useState<any>([]);
    const [pageSize, setPageSize] = useState(5);
    const [loading, setLoading] = useState<boolean>(true);
    const other_link: any = import.meta.env.VITE_APPURL!;

    const GetCustomerByIdList = () => {
        setLoading(true);
        let params: any = {};
        params.CustomerId = datas.customer.customerId;
        params.DeliveredPhoneNumber = datas.customer.phoneNumber;
        CustomerCommand.GetCustomerByIdList(params)
            .then((res: any) => {
                if (res) {
                    let parseData = res?.customerEmailList.map((item: any) => {
                        return {
                            customerNo: item.customerId || '-',
                            email: item.email || ' ',
                            isScr: item.isScr === true ? t('general.yes') : t('general.no'),
                            name: item.name + ' ' + item.surname || '-',
                            surname: item.surname || '-',
                            scrOperationDate:
                                item.scrOperationDate !== null
                                    ? TimeHelper.formatDateHour(item.scrOperationDate)
                                    : ' - ',
                        };
                    });
                    setCustomerByIdList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        GetCustomerByIdList();
    }, []);

    return (
        <Grid
            className={LAC.page}
            container
            size={{
                xl: 12,
                lg: 12,
                md: 12,
                xs: 12,
            }}
        >
            <Grid
                className={LAC.toolbarSection}
                sx={{ margin: '1rem' }}
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <Box className={LAC.loadingWrap} sx={{ marginBottom: '1rem' }}>
                    <SCUILoadingLinear display={loading} />
                </Box>
                <TextField
                    className={LAC.inputTextfieldCustomerPhone}
                    id="outlined-basic"
                    label={t('general.customerPhoneNumber')}
                    defaultValue={datas.customer?.phoneNumber}
                    disabled
                    size="small"
                    sx={{ marginTop: '0.9rem', marginBottom: '1rem' }}
                />
            </Grid>
            <Grid
                className={LAC.gridSection}
                sx={{ padding: '8px' }}
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <Box className={LAC.datagrid}>
                    <SCUICustomDataGrid
                        randomId
                        rows={customerByIdList}
                        columns={[
                            {
                                field: 'customerNo',
                                headerName: t('customerInformation.customerNo'),
                                flex: 1,
                                renderCell: (params: any) => {
                                    return (
                                        <div>
                                            <p
                                                className={lacCls('cursorPointer', LAC.inputLinkCustomerNo)}
                                                style={{ color: '#0d6efd' }}
                                                onClick={() => {
                                                    window.open(
                                                        other_link +
                                                            '/customerManagement?customerId=' +
                                                            params.row.customerNo,
                                                        '_blank'
                                                    );
                                                }}
                                            >
                                                <b>{params.row.customerNo}</b>
                                            </p>
                                        </div>
                                    );
                                },
                            },
                            { field: 'name', headerName: t('general.customerFullName'), flex: 1 },
                            { field: 'email', headerName: t('general.email'), flex: 1 },
                            {
                                field: 'isScr',
                                headerName: t('customerInformation.scr'),
                                flex: 1,
                            },
                            {
                                field: 'scrOperationDate',
                                headerName: t('general.scrOperationDate'),
                                flex: 1,
                            },
                        ]}
                        pageSize={pageSize}
                        onPageSizeChange={(i: number) => {
                            setPageSize(i);
                        }}
                    />
                </Box>
            </Grid>
        </Grid>
    );
};

